import { createSelector } from '@reduxjs/toolkit';

import { featureFlags } from '@modules/featureFlags/utils/featureFlags';
import { permissionsSel, urlUserIdSel } from '@shared';
import { organizationGuidSel } from '@shared/duck/selectors/general.selectors';
import { userIdSel } from '@user';

import { RootState } from '../../../root/store';
import { moduleName } from '../constants';
import type { PaymentLogsSliceState } from '../types';

const paymentLogsModuleSel = (state: RootState) =>
  state[moduleName] as PaymentLogsSliceState;

export const searchFilterSel = (state: RootState) =>
  paymentLogsModuleSel(state).searchFilter;
export const filtersSel = (state: RootState) =>
  paymentLogsModuleSel(state).filters;
export const unitFiltersSel = (state: RootState) =>
  paymentLogsModuleSel(state).unitFilters;
export const userGuidSel = (state: RootState) =>
  paymentLogsModuleSel(state).userGuid;
export const pastMemberSel = (state: RootState) =>
  paymentLogsModuleSel(state).pastMember;
export const selectedEditLogSel = (state: RootState) =>
  paymentLogsModuleSel(state).selectedEditLog;
export const sorterSel = (state: RootState) =>
  paymentLogsModuleSel(state).sorter;
export const selectedRowKeysSel = (state: RootState) =>
  paymentLogsModuleSel(state).selectedRowKeys;
export const paymentLogsActiveTabSel = (state: RootState) =>
  paymentLogsModuleSel(state).paymentLogsActiveTab;

export const queriedLogsSel = (state: RootState) =>
  paymentLogsModuleSel(state).queriedLogs;

export const queriedLogsFiltersSel = (state: RootState) =>
  paymentLogsModuleSel(state).queriedLogsFilters;

export const selectedRowKeysPerUnitSel = createSelector(
  selectedRowKeysSel,
  organizationGuidSel,
  (selectedRowKeys, orgGuid) => selectedRowKeys[orgGuid] ?? [],
);

export const currentUserIdSel = createSelector(
  urlUserIdSel,
  userIdSel,
  (urlUserId, selfUserId) => urlUserId || (selfUserId as number),
);

export const editAllowedSel = createSelector(
  permissionsSel,
  permissions => permissions['EDIT_YOUTH_PAYMENT_LOGS'] || false,
);

export const overrideShowUnitPaymentLogsSel = createSelector(
  organizationGuidSel,
  currentOrgGuid => {
    const overrideList =
      (featureFlags.getFlag(
        'SBL_5606_WHITELIST_UNIT_PAYMENT_LOGS',
      ) as string) || '';
    const unitGuids = new Set(overrideList.split(','));

    if (unitGuids.size === 0) return false;

    return unitGuids.has(currentOrgGuid);
  },
);
